export default (theme) => ({
  userAccountWrapper: {
    padding: '80px 80px 40px 100px',
    height: '100%',
    width: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('xl')]: {
      padding: '60px 60px 40px 80px',
    },
    [theme.breakpoints.down('md')]: {
      padding: 60,
      height: 'calc(100% - 60px)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: 40,
      height: 'calc(100% - 40px)',
    },
  },
});
